export type AdminStatTone = 'ink' | 'positive' | 'warning' | 'dim';

export interface AdminStatProps {
  label: string;
  value: string | number;
  sub: string;
  tone: AdminStatTone;
}

export function AdminStat({ label, value, sub, tone }: AdminStatProps) {
  return (
    <div className={'admin-stat tone-' + tone}>
      <div className="as-label">{label}</div>
      <div className="as-value">{value}</div>
      <div className="as-sub">{sub}</div>
    </div>
  );
}
